import React from "react";
import ProSourceForm from "../components/ProSourceForm";
import { Modal, Button, Form } from "react-bootstrap";
import { FormItem } from "../components/Base";
import { computeTotalCartAmount, GetSubmitClassList } from "../helpers";
import { REFUND_NOTES_CHAR_LIMIT } from "../constants";

export default class CancelNotesModal extends ProSourceForm {
  constructor(props) {
    super(props);

    const { order = {} } = this.props;
    // const max = computeTotalCartAmount(order.order_details)
    // console.log("cancel order: ", order)

    // const max = order.delivery
    //     ? order.isDeliveryCOD
    //         ? computeTotalCartAmount(order.order_details)
    //         : computeTotalCartAmount(order.order_details) + Number(order.chargedDeliveryFee)
    //     : computeTotalCartAmount(order.order_details);

    // console.log("max refund: ", max)

    this.state = {
      values: {
        refund_notes: "",
        refunded_amount: props.isReservation ? props.max : 0,
        order_type: "cancelled",
      },
      errors: {},
      touched: {},
      isSubmitting: false,
      max: this.props.max,
    };

    this.validate = {
      required: ["refund_notes", "refunded_amount"],
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.action !== this.props.action) {
      if (this.props.action === "reject") {
        this.setState((prevState) => {
          return {
            values: { ...prevState.values, refunded_amount: this.state.max },
          };
        });
      }
    }
  }

  handleOnChange = (event) => {
    const target = event.target,
      value = target.value,
      name = target.name;
    let { values, errors } = this.state;

    values[name] = value;
    if (name === "refund_notes" && value.length > REFUND_NOTES_CHAR_LIMIT) {
      errors[name] = "Exceeds character limit";
    } else {
      delete errors[name];
    }
    this.setState({
      values: values,
      errors,
    });

    this.setStateKey("touched", name, "true");
    this.validateForm();

    // checks if afterOnChange function exists
    this.onChange && this.onChange(event);
  };

  onChange = (event) => {
    const target = event.target,
      value = target.value,
      name = target.name;
    let { errors = {}, max = 0 } = this.state;

    if (name === "refunded_amount") {
      console.log("onChange max: ", this.state.max);
      if (value > max) {
        errors["refunded_amount"] =
          "Cannot issue refund higher than total amount.";
      } else if (value < 0) {
        errors["refunded_amount"] = "Cannot refund lower than zero amount.";
      } else {
        delete errors["refunded_amount"];
      }
    }

    this.setState({ errors });
  };

  onSubmit = (values, setSubmitting) => {
    this.props.onSubmit(values, setSubmitting);
  };

  render() {
    const {
        show = false,
        onHide,
        btnLoading = false,
        order = {},
        action = "",
        display_buttons,
        isReservation = false,
      } = this.props,
      { max = 0 } = this.state;

    const actions = {
        handleFeedbackError: this.handleFeedbackError,
        isTouched: this.isTouched,
      },
      inputActions = {
        onChange: this.handleOnChange,
        onBlur: this.handleOnBlur,
      };

    const cancelItemType = isReservation ? "reservation" : "order";
    return (
      <>
        <Modal show={show} onHide={onHide} centered>
          <Modal.Header>
            <Modal.Title style={{ textTransform: "capitalize" }}>
              Cancel {cancelItemType} #
              {
                order[
                  `${isReservation ? "reservation_" : "transaction_"}number`
                ]
              }
            </Modal.Title>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={this.props.onHide}
            >
              <i aria-hidden="true" className="ki ki-close"></i>
            </button>
          </Modal.Header>
          <Form onSubmit={this.handleOnSubmit}>
            <Modal.Body>
              <FormItem
                label={`Why are you cancelling this ${cancelItemType}?`}
                name={"refund_notes"}
                inputProps={{
                  name: "refund_notes",
                  placeholder: "Reason for cancellation",
                  value: this.state.values["refund_notes"],
                  rows: 5,
                  disabled: !display_buttons,
                }}
                inputActions={inputActions}
                actions={actions}
                type={"textarea"}
                normal
                showRequired
                helperText={
                  <>
                    {this.state.values["refund_notes"].length}/
                    {REFUND_NOTES_CHAR_LIMIT}
                  </>
                }
              />

              <FormItem
                label={"Amount to be refunded"}
                name={"refunded_amount"}
                inputProps={{
                  name: "refunded_amount",
                  placeholder: max.toFixed(2),
                  value: this.state.values["refunded_amount"],
                  max: max,
                  min: 0,
                  ...(action === "reject" ? { readOnly: "readonly" } : {}),
                  disabled: !display_buttons,
                }}
                inputActions={inputActions}
                actions={actions}
                type={"number"}
                normal
                showRequired
              />
            </Modal.Body>
            <Modal.Footer>
              {display_buttons ? (
                <Button
                  type="submit"
                  variant="danger"
                  className={GetSubmitClassList(btnLoading, "")}
                  disabled={btnLoading ? "disabled" : null}
                  style={{ textTransform: "capitalize" }}
                >
                  cancel {cancelItemType}
                </Button>
              ) : null}
            </Modal.Footer>
          </Form>
        </Modal>
      </>
    );
  }
}
